import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/**
 * Bell icon with unread badge (red bg + white text for contrast on dark header).
 */
export default function NotificationBellButton({
  onPress,
  unreadCount = 0,
  iconColor = '#F8FAFC',
  size = 24,
  style,
}) {
  const count = Math.max(0, Number(unreadCount) || 0);
  const label = count > 99 ? '99+' : String(count);

  return (
    <TouchableOpacity
      style={[styles.button, style]}
      onPress={onPress}
      hitSlop={8}
      accessibilityRole="button"
      accessibilityLabel={
        count > 0 ? `Notifikasi, ${count} belum dibaca` : 'Notifikasi'
      }
    >
      <Ionicons name="notifications-outline" size={size} color={iconColor} />
      {count > 0 ? (
        <View style={[styles.badge, count > 9 ? styles.badgeWide : null]}>
          <Text style={styles.badgeText} numberOfLines={1}>
            {label}
          </Text>
        </View>
      ) : null}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: -2,
    right: -4,
    minWidth: 18,
    height: 18,
    paddingHorizontal: 4,
    borderRadius: 9,
    backgroundColor: '#DC2626',
    borderWidth: 1.5,
    borderColor: '#0F172A',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  badgeWide: {
    minWidth: 22,
    paddingHorizontal: 5,
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 10,
    fontWeight: '700',
    lineHeight: 12,
    textAlign: 'center',
  },
});
